import kzFlag from '@/assets/icons/kz-flag.svg';
import ruFlag from '@/assets/icons/ru-flag.svg';
import enFlag from '@/assets/icons/en-flag.svg';
import kaFlag from '@/assets/icons/ka-flag.svg';
import kk from '@/assets/locales/kk.json';
import ru from '@/assets/locales/ru.json';
import en from '@/assets/locales/en.json';
import ka from '@/assets/locales/ka.json';
import hi from '@/assets/locales/hi.json';
import zh from '@/assets/locales/zh.json';
import uz from '@/assets/locales/uz.json';
import tr from '@/assets/locales/tr.json';

export const DEFAULT_LANGUAGES = [
	{
		name: 'Қазақ тілі',
		shortName: 'Қазақ',
		code: 'kk',
		label: 'Қаз',
		icon: kzFlag,
		messages: kk
	},
	{
		name: 'Русский язык',
		shortName: 'Русский',
		code: 'ru',
		label: 'Рус',
		icon: ruFlag,
		messages: ru
	},
	{
		name: 'English',
		shortName: 'English',
		code: 'en',
		label: 'Eng',
		icon: enFlag,
		messages: en
	}
] as const;

const ALL_LANGUAGES = [
	{
		name: 'ქართული',
		shortName: 'ქართული',
		code: 'ka',
		label: 'ქა',
		icon: kaFlag,
		messages: ka
	},
	...DEFAULT_LANGUAGES,
	{
		name: 'हिन्दी',
		shortName: 'हिन्दी',
		code: 'hi',
		label: 'हिं',
		messages: hi
	},
	{
		name: '中文',
		shortName: '中文',
		code: 'zh',
		label: '中',
		messages: zh
	},
	{
		name: 'Oʻzbekcha',
		shortName: 'Oʻzbekcha',
		code: 'uz',
		label: 'Oʻz',
		messages: uz
	},
	{
		name: 'Türkçe',
		shortName: 'Türkçe',
		code: 'tr',
		label: 'Tür',
		messages: tr
	}
] as const;

export default ALL_LANGUAGES;
